import { defaultApiClient } from "../libs";

export const fetch = async (campaignId, client) => {
  const { data } = await defaultApiClient.get(`/api/v1/campaign/${campaignId}`)
  return data.data
}
